// Gathering spots in Sunvale's bigger fields (tiles), shared by the zone builder (which keeps them clear) and the
// forage list (shared/world.ts), so the two always agree.
/** The Meadowlands' gathering spots in the new land to the east and south (tiles). Its old spots are kept. */
export const MEADOW_SPOTS = {
  orchard: [[66, 5], [70, 5], [74, 5], [68, 9], [72, 9], [76, 9], [66, 13], [70, 13], [74, 13]] as [number, number][],
  grove: [[86, 6], [90, 9], [85, 13], [91, 16], [87, 20], [84, 24]] as [number, number][],
  lake: [[80, 38], [71, 40], [88, 41], [80, 45]] as [number, number][],   // the end of the pier, and the shore
  quarry: [[87, 49], [91, 52], [88, 56], [92, 58], [85, 54]] as [number, number][],
  herbs: [[40, 50], [46, 54], [52, 49], [58, 55], [44, 58], [62, 50], [36, 56]] as [number, number][],
};
/** Whisperwood's new southern hollow: a woodcutters' camp, mushroom rings, ferns and a pond to fish. */
export const WOODS_SPOTS = {
  camp: [[26, 52], [31, 50], [35, 55], [28, 58]] as [number, number][],
  shrooms: [[12, 50], [16, 58], [9, 61], [50, 48]] as [number, number][],
  ferns: [[40, 61], [54, 52], [27, 47], [6, 56]] as [number, number][],
  pond: [[42, 56], [51, 56]] as [number, number][],
};
